/**
 * this file combines all reducers of the app
 *
 * Created by Tom on 23/05/18
 */

import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import { createResponsiveStateReducer } from 'redux-responsive'

import { componentState } from './componentReducers'
import { portfolioState } from './portfolioReducers'
import { investmentState } from './investmentReducers'
import { transactionState } from './transactionReducers'
import { newsState } from './newsReducers'
import { profileState } from './profileReducers'
import { fundState } from './fundReducers'
import { notificationsState } from './notificationsReducer'
import { documentsState } from './documentsReducers'
import { billingState } from './billingReducers'

// add all reducers here to match the initState
export default combineReducers({
    router: routerReducer,
    form: formReducer,
    browser: createResponsiveStateReducer({
        small: 720,
        medium: 1100,
        large: 1500
    }),
    componentState,
    portfolioState,
    investmentState,
    transactionState,
    newsState,
    profileState,
    fundState,
    notificationsState,
    documentsState,
    billingState
})



// WEBPACK FOOTER //
// ./src/reducers/index.js